/* eslint-disable @nx/enforce-module-boundaries */
import { Injectable, inject } from '@angular/core';
import { StatesService, StateStoreKeys } from '@socium/sociumflow';
import { LanguageCode } from '../../../../../../../libs/src';

/**
 * Service to manage language settings and preferences.
 */
@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly statesService = inject(StatesService);

  saveChangeLang(lang: string): void {
    this.statesService.setCookie(StateStoreKeys.LANGUAGE, lang.toUpperCase());
  }

  getUserLang(): string {
    return (
      this.statesService.getCookie<string>(StateStoreKeys.LANGUAGE) ||
      navigator.language ||
      LanguageCode.FR.toLowerCase()
    ).toLowerCase();
  }

  setUserLang(): void {
    const userLang = this.getUserLang();
    const language: string = userLang.split('-')[0];
    this.statesService.setCookie(
      StateStoreKeys.LANGUAGE,
      language.toUpperCase(),
    );
  }

  getUserTranslateLanguage(): string {
    const lang = this.statesService.getCookie<string>(StateStoreKeys.LANGUAGE);
    if (!lang) {
      this.setUserLang();
    }
    return this.getUserLang();
  }
}
